var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarNewImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2239_4)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M14.3548 0.84375C14.1064 0.328125 13.5814 0 13.0048 0C12.4282 0 11.9079 0.328125 11.6548 0.84375L8.64073 7.04531L1.90948 8.03906C1.34698 8.12344 0.878232 8.51719 0.704794 9.05625C0.531357 9.59531 0.671982 10.1906 1.07511 10.5891L5.95948 15.4219L4.80636 22.2516C4.71261 22.8141 4.94698 23.3859 5.41104 23.7188C5.87511 24.0516 6.48917 24.0938 6.99542 23.8266L13.0095 20.6156L19.0235 23.8266C19.5298 24.0938 20.1439 24.0562 20.6079 23.7188C21.072 23.3813 21.3064 22.8141 21.2126 22.2516L20.0548 15.4219L24.9392 10.5891C25.3423 10.1906 25.4876 9.59531 25.3095 9.05625C25.1314 8.51719 24.6673 8.12344 24.1048 8.03906L17.3689 7.04531L14.3548 0.84375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2239_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarNewImage);
export default __webpack_public_path__ + "static/media/star-new-image.d646f4fa5c5a7f58f0e58179a8ec9f95.svg";
export { ForwardRef as ReactComponent };